import { render, staticRenderFns } from "./detailed-information.vue?vue&type=template&id=0cc2fb1d"
import script from "./detailed-information.vue?vue&type=script&lang=ts"
export * from "./detailed-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports